import { ChevronLeftIcon, ChevronRightIcon, PlusIcon } from 'lucide-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

export type CollectionTableFooterProps = {
  loading?: boolean
  onNewRowClick: () => void
  previousPageDisabled?: boolean
  nextPageDisabled?: boolean
  onPreviousPageClick?: () => void
  onNextPageClick?: () => void
  pageNumber?: number
  pageSize?: number
  totalSize: number
  canEdit?: boolean
}

function _CollectionTableFooter (props: CollectionTableFooterProps) {
  const DEFAULT_PAGE_SIZE = 100

  const {
    loading,
    onNewRowClick,
    previousPageDisabled,
    nextPageDisabled,
    onPreviousPageClick,
    onNextPageClick,
    pageNumber = 0,
    pageSize = DEFAULT_PAGE_SIZE,
    totalSize,
    canEdit = false
  } = props
  const { t, i18n } = useTranslation()

  return (
    <div
      className="flex items-center w-full justify-between h-8 min-h-8 -mt-[1px] bg-base-100 border-y sticky bottom-0"
    >
      {canEdit && (
        <div
          onClick={onNewRowClick}
          role={loading ? 'none' : 'button'}
          className={clsx(
            loading && 'cursor-not-allowed',
            !loading && 'hover:bg-base-200',
            !loading && 'active:bg-base-300',
            'text-gray-600',
            'h-full',
            'px-4',
            'grow',
            'text-sm',
            'flex',
            'items-center',
            'cursor-pointer'
          )}
        >
          <div className="flex gap-1.5 items-center">
            <PlusIcon size={16} />
            {t('New record')}
          </div>
        </div>
      )}
      <div className="flex gap-2 mx-4 py-1 absolute right-0 items-center">
        <span className='text-xs'>
          {formatNumber(Math.min((pageNumber * pageSize) + 1, totalSize ?? 0), i18n.language)} - {formatNumber(Math.min((pageNumber + 1) * pageSize, totalSize ?? 0), i18n.language)} of {formatNumber(totalSize ?? 0, i18n.language)}
        </span>
        <div className='join'>
          <button
            className="join-item btn btn-xs"
            disabled={previousPageDisabled}
            onClick={onPreviousPageClick}
          >
            <ChevronLeftIcon size={16} />
          </button>
          <div className='flex items-center justify-center border-y-1 text-sm btn-xs min-w-8'>
            {pageNumber + 1}
          </div>
          <button
            className="join-item btn btn-xs"
            disabled={nextPageDisabled}
            onClick={onNextPageClick}
          >
            <ChevronRightIcon size={16} />
          </button>
        </div>
      </div>
    </div>
  )
}

function formatNumber (value: number, lang: string = 'en') {
  return new Intl.NumberFormat(lang, { notation: 'standard' }).format(value)
}

export const CollectionTableFooter = memo(_CollectionTableFooter)
